module.exports = __webpack_public_path__ + "static/media/3d-space-3.68f9ef94.png";